import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { FileUploadModule as NgxFileUploadModule } from '@iplab/ngx-file-upload';
import { FileUploadComponent } from './file-upload.component';
import { MaterialModule } from '@widgets/ui-common/material/material.module';
@NgModule({
  declarations: [FileUploadComponent],
  imports: [CommonModule, ReactiveFormsModule, NgxFileUploadModule, HttpClientModule, MaterialModule],
  exports: [FileUploadComponent]
})
export class FileUploadModule {}
